import React from 'react'
import { TooltipPositionTypes } from '../../../../libraries/Tooltips'
import { getMergedClassNames, getUniqueKey } from '../../../../utils/HTMLutils'
import Collapse from '../../../collapse/Collapse'
import './MenuItem.scss'
const rootClassName = 'component-menu-item'

export interface MenuItemProps {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  id?: string
  className?: string
  icon?: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  active?: boolean
  label?: string
  subListOpened?: boolean
  subList: {
    'tooltip-position'?: TooltipPositionTypes
    'tooltip-text'?: string
    id?: string
    className?: string
    icon?: React.ReactNode
    onClick?: () => void
    disabled?: boolean
    active?: boolean
    label?: string
  }[]
  buscar?: boolean
  buscarValue?: string
}

export default function MenuItem(props: MenuItemProps) {
  const handleClick = () => {
    if (!props.disabled) {
      props.onClick!()
    }
  }

  const getProps = () => {
    const p: any = {
      ...props,
      onClick: handleClick,
      className: getMergedClassNames([
        rootClassName,
        props.className,
        props.active ? `${rootClassName}-active` : ''
      ])
    }
    delete p.icon
    delete p.active
    delete p.subListOpened
    delete p.subList
    delete p.label
    delete p.buscar
    delete p.buscarValue
    delete p.hasPermission
    return p
  }

  return (
    <React.Fragment>
      <button {...getProps()}>
        <div className={`${rootClassName}-icon`}>{props.icon}</div>
        <div className={`${rootClassName}-label`}>{props.label}</div>
      </button>
      {props.subList && props.subList.length ? (
        <Collapse
          opened={Boolean(
            (props.buscar && props.buscarValue) || props.subListOpened
          )}
        >
          <div className={`${rootClassName}-sub-list`}>
            {props.subList.map((subItem) => {
              const itemClassNames = getMergedClassNames([
                `${rootClassName}-sub-item`,
                subItem.active ? `${rootClassName}-active` : ''
              ])
              const idAndKey = subItem.id ? subItem.id : getUniqueKey()
              return (
                <div
                  id={idAndKey}
                  className={itemClassNames}
                  key={idAndKey}
                  onClick={subItem.onClick}
                >
                  <div className={`${rootClassName}-sub-item-icon`}>
                    {subItem.icon}
                  </div>
                  <div className={`${rootClassName}-sub-item-label`}>
                    {subItem.label}
                  </div>
                </div>
              )
            })}
          </div>
        </Collapse>
      ) : undefined}
    </React.Fragment>
  )
}

MenuItem.defaultProps = {
  onClick: () => {},
  disabled: false,
  icon: '-',
  label: ''
}
